import { cx } from './cx';
import styles from './Toast.module.css';

export type ToastTone = 'info' | 'success' | 'error';

export interface ToastProps {
  message: string;
  tone?: ToastTone;
  /** Animates in/out with transform + opacity only. */
  visible: boolean;
  className?: string;
}

/** Presentational toast (bottom-centre). The app's `ui` slice owns the queue and timers. */
export function Toast({ message, tone = 'info', visible, className }: ToastProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      data-visible={visible || undefined}
      className={cx(styles.toast, styles[tone], visible && styles.visible, className)}
    >
      <span className={styles.bar} />
      <span className={styles.text}>{message}</span>
    </div>
  );
}
